<template>
  <div class="h5content patientImaging">
    <div class="imgItem" v-for="(row, index) in imgList" :key="index">
      <div class="toptitle P-Cursor row flex-center nb">
        <span>就诊时间： {{ row.name }}</span>
        <span>就诊医生： {{ row.doctorName }}</span>
      </div>

      <div class="row flex-wrap imgContent">
        <div class="imgListItem" v-for="img in row.list" :key="img.id">
          <div class="imgOutBox">
            <ViewPhotoItem :imgSrc="img.imageUrl" :imgList="row.imgview" />
            <div v-if="isImage(img)" class="shareBtn" @click="shareImg(img)">
              转发 <i class="iconfont icon-send"></i>
            </div>
          </div>

          <div class="imageDescription">{{ img.imageTypeLabel }}</div>
        </div>
      </div>
    </div>

    <EmptyImgh5 v-if="imgList.length == 0"></EmptyImgh5>
  </div>
</template>

<script>
import ViewPhotoItem from "@/components/publick/viewPhotoItem";
import { getPatientImages, uploadFileToWeChat } from "@/api/patient.js";
import { userStore } from "@/store/user.js";
import { loadingStore } from "@/store/loading.js";
import { useJuziSendStore } from "@/store/juzi/juziSend.js";
import { isJuzi } from "@/util/platform.js";
import { showToast } from "vant";

export default {
  name: "patientImaging",
  props: [],
  components: {
    ViewPhotoItem,
  },
  data() {
    return {
      thumbnail: "?x-oss-process=style/thumb", //预览图
      ossurl: "?x-oss-process=style/preview", //缩略图的url
      imgList: [],
    };
  },
  setup() {
    let loading = loadingStore();
    return {
      loading,
    };
  },
  mounted() {
    this.getImgList();
  },
  methods: {
    getImgList() {
      let that = this;
      const user = userStore();

      getPatientImages({
        corpId: user.corpId,
        cusId: user.cusId,
      }).then((res) => {
        let { data } = res.data;
        let imglist = [];
        data.forEach((img) => {
          let flag = false;
          imglist.forEach((item) => {
            if (item.name == img.appointTime) {
              flag = true;
              item.list.push(img);
              item.imgview.push(img.imageUrl);
            } else {
            }
          });
          if (!flag) {
            let additem = {
              name: img.appointTime,
              clinicId: img.clinicId,
              clinicName: img.clinicName,
              createUserName: img.createUserName,
              doctorName: img.doctorName,
              list: [img],
              imgview: [img.imageUrl],
            };
            imglist.push(additem);
          }
        });
        that.imgList = imglist;
      });
    },
    shareImg(img) {
      let that = this;

      const user = userStore();

      // 橘子平台支持直接通过图片 URL 发送，无需先上传企微临时素材。
      if (isJuzi()) {
        user.getWxconfig(["sendChatMessage"]).then(() => {
          const juziSend = useJuziSendStore();
          const sendParams = {
            msgtype: "image",
            image: {
              url: img.imageUrl,
              title: "",
            },
          };

          juziSend.sendImageMessage(sendParams, function (res) {
            if (res.err_msg === "sendChatMessage:ok") {
              
            }
            showToast(res.err_msg || "图片发送失败");
          });
        });
        return;
      }

      const subData = {
        agentId: user.agentId,
        corpId: user.corpId,
        type: "image",
        url: img.imageUrl,
      };
      // return
      that.loading.showLoading("正在上传临时素材");
      uploadFileToWeChat(subData).then((res) => {
        let mediaid = res.data.data;
        that.loading.hideLoading();
        
        user.getWxconfig(["sendChatMessage"]).then(()=>{
          user.shareImageToChat(mediaid);
        })

      });
    },
    isImage(img) {
      // 判断 img.imageUrl 是否为图片类型
      const imageExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".bmp",
        ".webp",
        ".heic",
      ];
      return imageExtensions.some((ext) => img.imageUrl.endsWith(ext));
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.patientImaging {
  text-align: left;

  .imgItem {
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 0.083rem;
    margin-bottom: 15px;

    .toptitle {
      font-size: 0.25rem;
      padding: 0.167rem 0.25rem;
      border-bottom: 1px solid #ededed;
      background: #f7f7f7;
      text-align: left;
      justify-content: space-between;

      &.nb {
        border-bottom: 1px solid #fff;
      }
    }

    .icon-sanjiao {
      color: #999999;
      margin-right: 0.104rem;
      position: relative;
      transition: all 0.3s;
      transform: rotate(-90deg);
    }

    .rightText {
      font-size: 0.25rem;
    }
  }

  .imgListItem {
    width: 33%;
    float: left;
    margin-top: 0.25rem;

    .imgOutBox {
      width: 1.792rem;
      height: 1.792rem;
      position: relative;
      margin: 0 auto;

      .shareBtn {
        background-color: rgba(0, 0, 0, 0.8);
        height: 0.5rem;
        line-height: 0.5rem;
        position: absolute;
        bottom: 0;
        color: #fff;
        font-size: 0.292rem;
        padding-left: 0.083rem;
        padding-right: 0.083rem;
        border-radius: 0 0.083rem 0 0;

        .icon-send {
          font-size: 0.333rem;
          vertical-align: -0.033rem;
        }
      }
    }

    .elImg {
      display: block;
      margin: 0 auto;
      width: 1.792rem;
      height: 1.792rem;
      background-color: #f7f7f7;
    }

    .imageDescription {
      text-align: center;
      color: #666666;
      font-size: 0.25rem;
      margin-top: 0.083rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 0.417rem;
      line-height: 0.417rem;
      padding: 0 0.208rem;
    }
  }
}
</style>
